import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const navLinks = [
  { label: 'Sobre', href: '#sobre' },
  { label: 'Serviços', href: '#servicos' },
  { label: 'Portfólio', href: '#portfolio' },
  { label: 'Contato', href: '#contato' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
          scrolled
            ? 'bg-[#0A0A0A]/95 backdrop-blur-md shadow-[0_4px_20px_rgba(0,0,0,0.4)]'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-[80px] md:h-[92px] relative">
          {/* Mobile Hamburger (left side on mobile) */}
          <button
            className="md:hidden flex flex-col gap-[5px] cursor-pointer z-50 p-2"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <span className={`block w-6 h-[2px] bg-white transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-[7px]' : ''}`} />
            <span className={`block w-6 h-[2px] bg-white transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />
            <span className={`block w-6 h-[2px] bg-white transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-[7px]' : ''}`} />
          </button>

          {/* Logo — centered on mobile, left on desktop */}
          <a
            href="#hero"
            onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
            className="flex items-center cursor-pointer md:static absolute left-1/2 -translate-x-1/2 md:translate-x-0 md:left-auto md:relative"
          >
            <img
              src="https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/a6719c99-f0d6-4ea7-b741-aecd2aa3bb32_logo-mares-Photoroom.png?v=5f0652c94aa2d2624baec1f6dfcf5bd8"
              alt="André Mares Arquitetura"
              className="h-[68px] w-auto object-contain"
            />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className="relative text-[#EDEDED] font-['Montserrat'] text-sm tracking-widest uppercase cursor-pointer group transition-colors duration-300 hover:text-white whitespace-nowrap"
              >
                {link.label}
                <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-[#A3B18A] transition-all duration-300 group-hover:w-full" />
              </a>
            ))}
            <a
              href="#contato"
              onClick={(e) => { e.preventDefault(); handleNavClick('#contato'); }}
              className="ml-4 px-6 py-2.5 border border-[#A3B18A] text-[#A3B18A] font-['Montserrat'] text-sm tracking-widest uppercase rounded-full hover:bg-[#A3B18A] hover:text-[#0A0A0A] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Fale Conosco
            </a>
          </nav>

          {/* Spacer on mobile to balance hamburger */}
          <div className="md:hidden w-10" />
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 z-40 flex flex-col items-center justify-center transition-all duration-500 md:hidden ${
          menuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        style={{ background: 'rgba(10,10,10,0.98)', backdropFilter: 'blur(20px)' }}
      >
        <nav className="flex flex-col items-center gap-8">
          {navLinks.map((link, i) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className="text-[#EDEDED] font-['Montserrat'] text-2xl tracking-widest uppercase cursor-pointer hover:text-[#A3B18A] transition-colors duration-300"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contato"
            onClick={(e) => { e.preventDefault(); handleNavClick('#contato'); }}
            className="mt-4 px-8 py-3 border border-[#A3B18A] text-[#A3B18A] font-['Montserrat'] text-base tracking-widest uppercase rounded-full hover:bg-[#A3B18A] hover:text-[#0A0A0A] transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Fale Conosco
          </a>
        </nav>
      </div>
    </>
  );
}
